/* Aphrodisiac homepage: hero slideshow, spell tabs, add-three buttons */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlideshow(el) {
    if (el.getAttribute('data-aph-ready')) return;
    el.setAttribute('data-aph-ready', '1');
    var slides = el.querySelectorAll('.aph-hero__slide');
    var count = slides.length;
    if (!count) return;
    var groups = el.querySelectorAll('[data-aph-group]');
    var dots = el.querySelectorAll('[data-aph-dot]');
    var delay = parseInt(el.getAttribute('data-autoplay') || '0', 10);
    var index = 0;
    var timer = null;

    function go(n) {
      index = (n + count) % count;
      for (var s = 0; s < count; s++) slides[s].classList.toggle('is-active', s === index);
      for (var g = 0; g < groups.length; g++) {
        var kids = groups[g].children;
        for (var k = 0; k < kids.length; k++) kids[k].classList.toggle('is-active', k === index);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
        dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
      }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (delay > 0 && count > 1 && !reduceMotion) timer = setInterval(function () { go(index + 1); }, delay);
    }
    var prev = el.querySelector('[data-aph-prev]');
    var next = el.querySelector('[data-aph-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function () { go(i); start(); });
    });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    el.addEventListener('focusin', stop);
    go(0);
    start();
  }

  function initTabs(el) {
    if (el.getAttribute('data-aph-ready')) return;
    el.setAttribute('data-aph-ready', '1');
    var tabs = Array.prototype.slice.call(el.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(el.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      var bg = tabs[i].getAttribute('data-bg');
      if (bg) el.style.setProperty('--aph-spell-bg', bg);
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((k + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((k - 1 + tabs.length) % tabs.length, true); }
      });
    });
    el.aphSelect = function (key) {
      for (var k = 0; k < tabs.length; k++) {
        if (tabs[k].getAttribute('data-spell') === key) { select(k); return; }
      }
    };
    select(0);
  }

  function initAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-aph-slideshow]'), initSlideshow);
    Array.prototype.forEach.call(s.querySelectorAll('[data-aph-tabs]'), initTabs);
  }

  /* Spell circles open the matching story tab */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-aph-spell-link]');
    if (!link) return;
    var tabsEl = document.querySelector('[data-aph-tabs]');
    if (tabsEl && tabsEl.aphSelect) tabsEl.aphSelect(link.getAttribute('data-aph-spell-link'));
  });

  /* Add all three buttons add several bottles, then open the cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aph-add-items]');
    if (!btn) return;
    e.preventDefault();
    var ids = (btn.getAttribute('data-aph-add-items') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = root + 'cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tabsEl = e.target.closest && e.target.closest('[data-aph-tabs]');
    var key = e.target.getAttribute && e.target.getAttribute('data-spell-panel');
    if (tabsEl && tabsEl.aphSelect && key) tabsEl.aphSelect(key);
  });
})();
